import { ofetch } from 'ofetch';
import { captureMonitoringException, trackMonitoringEvent } from '~/utils/monitoring';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const { interviewStatus } = useResume()
  // 创建封装后的实例
  const $myFetch = ofetch.create({
    baseURL: config.public.apiBase,
    timeout: 5 * 60 * 1000,
    // 请求拦截器 (自动添加 Token)
    async onRequest({ request, options }) {
      // 自动添加 Authorization header
      if (import.meta.client) {
        try {
          const token = localStorage.getItem('practice_account_token')
          if (token) {
            // 如果 options.headers 不存在，创建它
            if (!options.headers) {
              options.headers = {}
            }
            // 如果 options.headers 是 Headers 对象，使用 set 方法
            if (options.headers instanceof Headers) {
              options.headers.set('Authorization', `Bearer ${token}`)
            } else {
              // 如果是普通对象，直接设置
              options.headers['Authorization'] = `Bearer ${token}`
            }
          }
        } catch (error) {
          console.error('添加Authorization header失败:', error)
        }
      }
      if (import.meta.client) {
        const method = typeof options.method === 'string' ? options.method.toUpperCase() : 'GET'
        const url = typeof request === 'string' ? request : request?.toString?.() || 'unknown'

        if (method !== 'GET') {
          trackMonitoringEvent('api_request', { method, url })
        }
      }
    },

    // 响应拦截器 (统一错误处理)
    async onResponseError({ request, response, options }) {
      console.log(response, "response error")
      const method = typeof options?.method === 'string' ? options.method.toUpperCase() : 'GET'
      const url = typeof request === 'string' ? request : request?.toString?.() || 'unknown'
      
      // 处理 401 未授权错误（token过期或无效）
      if (response.status === 401 && import.meta.client) {
        trackMonitoringEvent('api_unauthorized', { method, url, status: response.status })
        // 清除本地存储的token和用户信息
        try {
          localStorage.removeItem('practice_account_token')
          localStorage.removeItem('practice_account_info')
        } catch (error) {
          console.error('清除token失败:', error)
        }
        
        // 如果不是在登录页，跳转到登录页
        if (typeof window !== 'undefined' && !window.location.pathname.includes('/')) {
          window.location.href = '/'
        }
      }

      if (import.meta.client && response.status >= 500) {
        captureMonitoringException(new Error(`API request failed: ${method} ${url}`), {
          tags: {
            module: 'api',
            http_status: String(response.status)
          },
          context: {
            method,
            url,
            status: response.status,
            response: response._data
          }
        })
      }
      
      const _data = response._data
      if (_data.ongoing_interview) {
        const { ongoing_interview } = _data
        interviewStatus.value.ongoing_thread = ongoing_interview
        interviewStatus.value.eligible = true
        interviewStatus.value.showResumeTip = true
      }
      return Promise.reject(response)
    }
  })

  // 注入全局上下文
  nuxtApp.provide('myFetch', $myFetch)
})
